module.exports = __webpack_public_path__ + "img/password_icon.265b629c.svg";